import i18n from 'i18n-react';
import { isUndefined, forEach } from 'lodash';

export function appDataReducerAlerts(state, action) {
    const errorMessages = [];
    const successMessages = [];

    if (action.type === 'ERROR') {
        let errorResponse;
        try {
            errorResponse = JSON.parse(action.errors.error.message);
        } catch (e) {
            console.error('Cannot parse JSON', e, errorResponse);
        }

        if (!errorResponse) {
            // Err, some bogus reply.
            errorMessages.push({ message: 'No data received from Hub' });
        } else if (typeof errorResponse.errors !== 'undefined' && errorResponse.errors.length > 0) {
            if (typeof errorResponse.message !== 'undefined') {
                errorMessages.push({ message: errorResponse.message });
            }

            // Loop through all errors and return them as the response of the call
            forEach(errorResponse.errors, (errors) => {
                if (isUndefined(errors.message)) {
                    return;
                }

                let messageOfError = '';
                if (!isUndefined(errors.source) && errors.source !== null) {
                    messageOfError = errors.source + ': ';
                }
                messageOfError += errors.message;

                errorMessages.push({ message: messageOfError });
            });
        } else if (typeof errorResponse.error_codes !== 'undefined') {
            if (errorResponse.error_codes.length === 0) {
                // Provide a default error message if FlexWeb HUB provides none
                errorMessages.push({
                    message: i18n.translate('general.alert.error.connectionErrorWithHUB'),
                });
            } else {
                // Loop through all error messages and return them as the response of the call
                forEach(errorResponse.error_codes, (val, key) => {
                    if (val && !isUndefined(val['nl-NL'])) {
                        errorMessages.push({ message: val['nl-NL'] });
                    }
                });

                if (errorMessages.length === 0) {
                    errorMessages.push({ message: errorResponse.message });
                }
            }
        } else if (typeof errorResponse.message !== 'undefined') {
            errorMessages.push({ message: errorResponse.message });
        }
    } else if (action.type === 'SUCCESS') {
       
        const successResponse = action.success.message;
 
        for (const message in successResponse.success_codes) {
            const successMessage = {
                message: successResponse.success_codes[message]['nl-NL'],
            };
            successMessages.push(successMessage);
        }

        if (successResponse?.message) {
            const successMessage = {
                message: successResponse?.message
            };
            successMessages.push(successMessage);

        }
    }

    return {
        errors: errorMessages,
        successes: successMessages,
    };
}
